import React from 'react';
import { useHistory } from 'react-router-dom'
import {
  setLoader,
} from "../../redux/loader/loader.actions";
import { useDispatch } from "react-redux";

import { StyledInnerLink } from './StyledInnerLink';

const InnerLink = () => {
  let history = useHistory();
  const dispatch = useDispatch();
  const handleCLick = (slug) => {
    if(history.location.pathname !== slug){
      dispatch(setLoader(true))
      setTimeout(() =>{  
        document.body.scrollTop = 0;
        history.push(slug)
      }, 500);
    }
  }
  return (
    <React.Fragment>
      {
       
          <StyledInnerLink>
            <h3 className="md--title gradient-cpg" onClick={() => handleCLick('/industries/cpg')}>
              CPG
            </h3>
            <h3 className="md--title gradient-real" onClick={() => handleCLick('/industries/real-estate')}>
              Real Estate
            </h3>
            <h3 className="md--title gradient-interior" onClick={() => handleCLick('/industries/interior-design')}>
              Interior Design
            </h3>
            <h3 className="md--title gradient-fashion" onClick={() => handleCLick('/industries/fashion')}>
              Fashion
            </h3>
            <h3 className="md--title gradient-more" onClick={() => handleCLick('/industries/generic')}>
              And more
            </h3>
            
          </StyledInnerLink>
          
      }
    </React.Fragment>
  );
};

export default InnerLink;
